export const cartInfo = 'cartInfo';
export const servicesInfo = 'servicesInfo';
export const basketSetDegraded = 'basketSetDegraded';
export const userAuth = 'user-auth';
export const cartId = 'cartId';
export const newCartSync = '_newCartSync';
